import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-check-mark {
  & .check-mark-partially-checked {
    & .p-checkbox-box {
      border-color: ${dt('checkbox.checked.border.color')};
      background: ${dt('checkbox.checked.background')};

      & .p-checkbox-icon {
        color: ${dt('checkbox.icon.checked.color')};
      }
    }
  }
}`;
